// src/App.tsx
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { BrandingProvider } from '@/contexts/BrandingContext';
import { LogoProvider } from '@/contexts/LogoContext';
import { router } from '@/router';
import { AlertWebhookProvider } from '@/components/providers/AlertWebhookProvider';

function App() {
  return (
    <AuthProvider>
      <BrandingProvider>
        <LogoProvider>
          <AlertWebhookProvider>
          <RouterProvider router={router} />
          </AlertWebhookProvider>
        </LogoProvider>
      </BrandingProvider>
    </AuthProvider>
  );
}

export default App;